/* eslint-disable operator-linebreak */

// determine whether a value is a representation of true
// accepted values are
//  · true, 'true'
//  · 1, '1'
//  · 'yes' y'
//  · 'true' 't'

function isTrue(value) {
  // accepts only: true, 1, 'y', 'yes', 't', 'true', '1'
  if (typeof value === 'boolean') {
    return value === true
  }

  if (typeof value === 'number') {
    return value === 1
  }

  if (typeof value === 'string') {
    const string = value.toLowerCase()
    return (
      string === 'y' ||
      string === 'yes' ||
      string === 't' ||
      string === 'true' ||
      string === '1'
    )
  }
  return false
}

export default isTrue
